export default __webpack_public_path__ + "static/media/background.310015f3.jpg";